import {
  AVATAR_CATALOG,
  getAvatarOption,
  getCompatibleHairStyles,
  isValidAvatarOption,
} from './AvatarCatalog';

export const AVATAR_VERSION = 1;

const pickId = (category, candidate, fallback) =>
  isValidAvatarOption(category, candidate) ? candidate : fallback;

export const createDefaultAvatar = (legacy = {}) => {
  const base = legacy.explorer === 'exploradora' ? 'exploradora' : 'explorador';
  const suitAccent = pickId('suitAccents', legacy.color, 'cyan');
  return {
    version: AVATAR_VERSION,
    base,
    skinTone: 'medium-light',
    hairStyle: getCompatibleHairStyles(base)[0].id,
    hairColor: 'dark-brown',
    suitAccent,
  };
};

// Normaliza datos nuevos, antiguos o dañados sin perder el perfil ni el progreso.
export const normalizeAvatar = (candidate, legacy = {}) => {
  const defaults = createDefaultAvatar(legacy);
  const source = candidate && typeof candidate === 'object' ? candidate : {};
  const base = source.base === 'exploradora' ? 'exploradora' : source.base === 'explorador' ? 'explorador' : defaults.base;
  const compatibleHair = getCompatibleHairStyles(base);
  const requestedHair = getAvatarOption('hairStyles', source.hairStyle);
  const hairStyle = requestedHair && requestedHair.compatibleBases.includes(base)
    ? requestedHair.id
    : compatibleHair[0].id;

  return {
    version: AVATAR_VERSION,
    base,
    skinTone: pickId('skinTones', source.skinTone, defaults.skinTone),
    hairStyle,
    hairColor: pickId('hairColors', source.hairColor, defaults.hairColor),
    suitAccent: pickId('suitAccents', source.suitAccent || legacy.color, defaults.suitAccent),
  };
};

export const avatarToLegacyProfile = avatar => ({
  explorer: avatar.base,
  color: avatar.suitAccent,
});

export const randomAvatar = (random = Math.random, legacy = {}) => {
  const base = AVATAR_CATALOG.bases[Math.floor(random() * AVATAR_CATALOG.bases.length)].id;
  const hairStyles = getCompatibleHairStyles(base);
  return normalizeAvatar({
    base,
    skinTone: AVATAR_CATALOG.skinTones[Math.floor(random() * AVATAR_CATALOG.skinTones.length)].id,
    hairStyle: hairStyles[Math.floor(random() * hairStyles.length)].id,
    hairColor: AVATAR_CATALOG.hairColors[Math.floor(random() * AVATAR_CATALOG.hairColors.length)].id,
    suitAccent: AVATAR_CATALOG.suitAccents[Math.floor(random() * AVATAR_CATALOG.suitAccents.length)].id,
  }, legacy);
};

// Authenticated preference only; missing/corrupt data never assigns a character.
export const studentAvatarBase = student =>
  isValidAvatarOption('bases', student?.avatar?.base) ? student.avatar.base : null;
